export default __webpack_public_path__ + "static/media/behavior_reading_deficits_table1.c6d7b24b.png";